export enum DocumentType {
    PRIVACY_POLICY = 'PrivacyPolicy',
    FINANCING_HANDBOOK = 'FinancingHandbook',
    ADVANCE_POLICY_FORM = 'AdvancePolicyForm',
    DOC_CHECKLIST_LEASE = 'DocumentChecklistLease',
    DOC_CHECKLIST_RETAIL = 'DocumentChecklistRetail',
    DRIVERS_OPTION = 'DriversOptionsNLNSNBPE',
    ONE_PAY = 'OnePay',
    INSUARANCE_INFO_VERIFICATION = 'InsuranceInfoVerification',
    PRE_AUTHORIZED_PAYMENT_FORM = 'PreAuthorizedPymntForm',
    CDE_CORPORATE_RESOLUTION = 'CDECorporateResolution',
    REFUNDABLE_SECURITY_DEPOSIT = 'RefundableSecurityDeposit',
    LEASE_TRANSFER_WORKSHEET = 'LeaseTransferWorksheetForm',
    LEASE_TRANSFER_CHECKLIST = 'LeaseTransferChecklist',
    CERTIFICATION = 'Certification',
    COMMERCIAL_CREDIT_APP = 'CommercialCreditApp',
    COMMERCIAL_CREDIT_APP_QC = 'CommercialCreditAppQC',
    CONSUMER_CREDIT_APP = 'ConsumerCreditApp',
    CONSUMER_CREDIT_APP_QC = 'ConsumerCreditAppQuebec',
    CUSTOMER_IDENTIFICATION_FORM = 'CustomerIdentificationForm',
    LEASE_PULL_AHEAD_FORM = 'LeasePullAheadForm',
    LEASE_TERM_EXTENTION = 'LeaseTermExtention',

    NON_MONTHLY_SCHEDULE_FORM = 'NonMonthlyScheduleForm',
    ODOMETER_DISCLOSURE_STATEMENT = 'OdometerDisclosureStmt',
    ASSET_MANAGEMENT_GROUP = 'AssetManagementGroup',
    AUDI_CARE_FORM = 'AudiCareForm',
    AUDI_CARE_FORM_CA = 'AudiCareFormCA',
    AUTOPAYMENT_CANCEL_FORM = 'AutoPaymentCancelForm',
    BONUS_RESEARCH_REQUEST = 'BonusResearchRequest',
    BUSINESS_CREDIT_APP = 'BusinessCreditApplication',
    CALIFORNIA_PRIVACY_POLICY = 'CaliforniaPrivacyPolicy',
    CDE_CONTACT_INFO = 'CDEContactInfo',
    CONSUMER_AUTO_PAYMENT_FORM = 'ConsumerAutoPaymentForm',
    CONTACT_INFORMATION = 'Contact Information',
    CORPORATE_RESOLUTION = 'CorporateResolution',
    CREDIT_APPLICATION_PRIVACY_POLICY = 'CreditApplicationPrivacyPolicy',
    CREDIT_FUNDING_AND_DEALER_RESERVE_STAFF = 'CreditFundingAndDealerReserveStaff',
    CSC_CORGANIZATIONAL_CHART = 'CSCOrganizationalChart',
    CTTRADE_INWORKSHEET = 'CTTrade-InWorksheet',
    DEALER_RESERVE_DISCREPANCY_FORM = 'DealerReserveDiscrepancyForm',
    DRIVERS_OPTIONS_BCABSKMBON = 'DriversOptionsBCABSKMBON',
    EV_LEASE_ADDENDUM_KANSAS = 'ElectricVehicleLeaseAddendumKansas',
    EV_LEASE_ADDENDUM_MULTI_STATE = 'ElectricVehicleLeaseAddendumMultiState',
    EV_LEASE_ADDENDUM_WISCONSIN = 'ElectricVehicleLeaseAddendumWisconsin',
    EMPLOYMENT_VERIFICATION_AUTH = 'EmploymentVerificationAuthorizationForm',
    ESE_ADP_BLUE_ZONE = 'ESEADPBluezone',
    ESE_ADP_REFLECTION = 'ESEADPReflections',
    ESE_REYNOLDS = 'ESEReynolds',
    ESE_UPLOAD = 'ESEUpload',
    EV_BUNDLE_ACK_FORM = 'EVBundleAcknowledgementForm',
    EV_DSL_ADDENDUM_CA = 'EVDealerServiceLoanerAddendumCA',
    EV_DSL_ADDENDUM_IL = 'EVDealerServiceLoanerAddendumIL',
    EV_DSL_ADDENDUM_MO = 'EVDealerServiceLoanerAddendumMO',
    EV_DSL_ADDENDUM_MULTI_STATE = 'EVDealerServiceLoanerAddendumMultiState',
    EV_DSL_ADDENDUM_NY = 'EVDealerServiceLoanerAddendumNY',
    EV_DSL_ADDENDUM_UT = 'EVDealerServiceLoanerAddendumUT',
    EV_DSL_ADDENDUM_VT = 'EVDealerServiceLoanerAddendumVT',
    EV_DSL_ADDENDUM_WI = 'EVDealerServiceLoanerAddendumWI',
    FOREIGN_BUSINESS_PROF_PROG_CHECKLIST = 'ForeignBusinessProfessionalProgramChecklist',
    FUNDING_CHECKLIST = 'FundingChecklist',
    ID_VERIFICATION_FORM = 'IDVerificationForm',
    IL_INTERPRETER_VERIFICATION = 'ILInterpreterVerification',
    INSURANCE_FORM = 'InsuranceForm',
    LAW_PRINTING_ORDER_FORM = 'LawPrintingOrderForm',
    MISC_EMPLOYEES_PHONE_LIST = 'MiscEmployeesPhoneList',
    NEW_MEXICO_INSURANCE_NOTICE_ALLRETAILS = 'NewMexicoInsuranceNoticeAllRetails',
    NEW_MEXICO_INSURANCE_NOTICE_DEALERAUTH = 'NewMexicoInsuranceNoticeDealerAuth',
    NOTICE_TO_COSIGNER_LEASE_CALIFORNIA = 'NoticetoCoSignerLeaseCalifornia',
    NOTICE_TO_COSIGNER_LEASE_COLORADO = 'NoticetoCoSignerLeaseColorado',
    NOTICE_TO_COSIGNER_LEASE_CONNECTICUT = 'NoticetoCoSignerLeaseConnecticut',
    NOTICE_TO_COSIGNER_LEASE_FEDERAL = 'NoticetoCoSignerLeaseFederal',
    NOTICE_TO_COSIGNER_LEASE_IOWA = 'NoticetoCoSignerLeaseIowa',
    NOTICE_TO_COSIGNER_LEASE_NORTHCAROLINA = 'NoticetoCoSignerLeaseNorthCarolina',
    NOTICE_TO_COSIGNER_LEASE_PENNSYLVANIA = 'NoticetoCoSignerLeasePennsylvania',
    NOTICE_TO_COSIGNER_LEASE_SOUTHCAROLINA = 'NoticetoCoSignerLeaseSouthCarolina',
    NOTICE_TO_COSIGNER_LEASE_TEXAS = 'NoticetoCoSignerLeaseTexas',
    NOTICE_TO_COSIGNER_LEASE_WISCONSIN = 'NoticetoCoSignerLeaseWisconsin',
    NOTICE_TO_COSIGNER_RETAIL_COLORADO = 'NoticetoCoSignerRetailColorado',
    NOTICE_TO_COSIGNER_RETAIL_FEDERAL = 'NoticetoCoSignerRetailFederal',
    NOTICE_TO_COSIGNER_RETAIL_ILLINOIS = 'NoticetoCoSignerRetailIllinois',
    NOTICE_TO_COSIGNER_RETAIL_IOWA = 'NoticetoCoSignerRetailIowa',
    NOTICE_TO_COSIGNER_RETAIL_NEWYORK = 'NoticetoCoSignerRetailNewYork',
    NOTICE_TO_COSIGNER_RETAIL_NORTHCAROLINA = 'NoticetoCoSignerRetailNorthCarolina',
    NOTICE_TO_COSIGNER_RETAIL_PENNSYLVANIA = 'NoticetoCoSignerRetailPennsylvania',
    NOTICE_TO_COSIGNER_RETAIL_SOUTHCAROLINA = 'NoticetoCoSignerRetailSouthCarolina',
    NOTICE_TO_COSIGNER_RETAIL_TEXAS = 'NoticetoCoSignerRetailTexas',
    NOTICE_TO_COSIGNER_RETAIL_WISCONSIN = 'NoticetoCoSignerRetailWisconsin',
    NOTICE_TO_COSIGNER_RETAIL_CALIFORNIA = 'NoticetoCoSignerRetailCalifornia',
    NOTICE_TO_GUARANTOR_RETAIL_ILLINOIS = 'NoticetoGurantorRetailIllinois',
    OPT_IN_PRIVACY_POLICY = 'OptInPrivacyPolicy',
    OPT_OUT_PRIVACYPOLICY = 'OptOutPrivacyPolicy',
    ORDER_FORM = 'OrderForm',
    PERSONAL_REF_FORM = 'PersonalReferencesForm',
    PSC_CREDIT_FUNDINGSTAFF = 'PSCCreditFundingStaff',
    PSC_ORGAZINATIONAL_CHART = 'PSCOrgazinationalChart',
    SERVICE_LOANERFAQ = 'ServiceLoanerFAQ',
    SERVICE_RENTALFAQ = 'ServiceRentalFAQ',
    SOUTHCAROLINA_TAX_CREDIT_WORKSHEET_FORM = 'SouthCarolinaTaxCreditWorksheetForm',
    SPEEDY_FAX = 'SpeedyFax',
    SYSTEM_REQUIREMENT = 'SystemRequirement',
    TERMS_AND_CONDITIONS = 'TermsAndConditions',
    TITLE_GROUP_CONTACT_LIST = 'TitleGroupContactList',
    USAGE_AGREEMENT = 'UsageAgreement',
    VISA_ACCEPTTERMS_FORM = 'VisaAcceptTermsForm',
    WISONSIN_TAX_CREDIT_WORKSHEET_FORM = 'WisonsinTaxCreditWorksheetForm',
    ORDER_FORMS = 'OrderForms',
}

export enum Language {
    EN = 'en',
    FR = 'fr',
}
